/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbJustificatifAbsenceGridDto } from './FcbJustificatifAbsenceGridDto';
import {
    FcbJustificatifAbsenceGridDtoFromJSON,
    FcbJustificatifAbsenceGridDtoFromJSONTyped,
    FcbJustificatifAbsenceGridDtoToJSON,
} from './FcbJustificatifAbsenceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbJustificatifAbsenceGridDtoPaginatedResults
 */
export interface FcbJustificatifAbsenceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbJustificatifAbsenceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbJustificatifAbsenceGridDto>}
     * @memberof FcbJustificatifAbsenceGridDtoPaginatedResults
     */
    results?: Array<FcbJustificatifAbsenceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbJustificatifAbsenceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbJustificatifAbsenceGridDtoPaginatedResults interface.
 */
export function instanceOfFcbJustificatifAbsenceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbJustificatifAbsenceGridDtoPaginatedResultsFromJSON(json: any): FcbJustificatifAbsenceGridDtoPaginatedResults {
    return FcbJustificatifAbsenceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbJustificatifAbsenceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbJustificatifAbsenceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbJustificatifAbsenceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbJustificatifAbsenceGridDtoPaginatedResultsToJSON(value?: FcbJustificatifAbsenceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbJustificatifAbsenceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

